import PropTypes from 'prop-types';

export default function ArrowBackIcon(props) {
    const { color="currentColor", className } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      fill="none"
      viewBox="0 0 30 30"
      className={className}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M17.317 10.808a.625.625 0 010 .884L14.009 15l3.308 3.308a.625.625 0 11-.884.884l-3.75-3.75a.625.625 0 010-.884l3.75-3.75a.625.625 0 01.884 0z"
        clipRule="evenodd"
      />
    </svg>
  );
}

ArrowBackIcon.propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
}